// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ZoomOutOutlinedSvg from "@fishx/icons-svg/es/asn/ZoomOutOutlined";
import FishxIcon from '../components/FishxIcon';

var ZoomOutOutlined = function ZoomOutOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ZoomOutOutlinedSvg
  }));
};

ZoomOutOutlined.displayName = 'ZoomOutOutlined';
export default React.forwardRef(ZoomOutOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ZoomOutOutlined.js
// module id = 4431
// module chunks = 0